/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import React, { useEffect, useState } from 'react';
import { TextInput } from '@carbon/react';
import { useTranslation } from 'react-i18next';

function TestToolDigestAuth({ digestCreds, onChange }) {
  const [digestUsername, setDigestUsername] = useState('');
  const [digestRealm, setDigestRealm] = useState('');
  const [digestNonce, setDigestNonce] = useState('');
  const [digestOpaque, setDigestOpaque] = useState('');
  const [digestResponse, setDigestResponse] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    setDigestUsername(digestCreds.digestUsername ?? '');
    setDigestRealm(digestCreds.digestRealm ?? '');
    setDigestNonce(digestCreds.digestRealm ?? '');
    setDigestOpaque(digestCreds.digestOpaque ?? '');
    setDigestResponse(digestCreds.digestResponse ?? '');
  }, [digestCreds.digestOpaque, digestCreds.digestRealm, digestCreds.digestResponse, digestCreds.digestUsername]);

  const handleHttpDigestUsernameChange = (event) => {
    const digestUsername = event.target.value;
    setDigestUsername(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ digestUsername, digestRealm, digestNonce, digestOpaque, digestResponse });
    }
  };

  const handleHttpDigestRealmChange = (event) => {
    const digestRealm = event.target.value;
    setDigestRealm(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ digestUsername, digestRealm, digestNonce, digestOpaque, digestResponse });
    }
  };

  const handleHttpDigestNonceChange = (event) => {
    const digestNonce = event.target.value;
    setDigestNonce(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ digestUsername, digestRealm, digestNonce, digestOpaque, digestResponse });
    }
  };

  const handleHttpDigestOpaqueChange = (event) => {
    const digestOpaque = event.target.value;
    setDigestOpaque(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ digestUsername, digestRealm, digestNonce, digestOpaque, digestResponse });
    }
  };

  const handleHttpDigestResponseChange = (event) => {
    const digestResponse = event.target.value;
    setDigestResponse(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ digestUsername, digestRealm, digestNonce, digestOpaque, digestResponse });
    }
  };

  return (
    <div className="testToolDigestAuth">
      <div className="digestusername">
        <div className="labelText">{t('username')}</div>
        <TextInput id="digestusername" hideLabel labelText={t('username')} value={digestUsername} onChange={handleHttpDigestUsernameChange} />
      </div>

      <div className="digestrealm">
        <div className="labelText">{t('realm')}</div>
        <TextInput id="digestrealm" labelText={t('realm')} hideLabel value={digestRealm} onChange={handleHttpDigestRealmChange} />
      </div>

      <div className="digestnonce">
        <div className="labelText">{t('nonce')}</div>
        <TextInput id="digestnonce" labelText={t('nonce')} hideLabel value={digestNonce} onChange={handleHttpDigestNonceChange} />
      </div>

      <div className="digestopaque">
        <div className="labelText">{t('opaque')}</div>
        <TextInput id="digestopaque" labelText={t('opaque')} hideLabel value={digestOpaque} onChange={handleHttpDigestOpaqueChange} />
      </div>

      <div className="digestresponse">
        <div className="labelText">{t('response')}</div>
        <TextInput id="digestresponse" labelText={t('response')} hideLabel value={digestResponse} onChange={handleHttpDigestResponseChange} />
      </div>
    </div>
  );
}

export default TestToolDigestAuth;
